<div class="h-0 min-h-full flex-1">
  @if (guaranteeApplications().length > 0) {
    @for (guarantee of guaranteeApplications(); track guarantee.id) {
      <div
        class="mb-3 box-border flex shrink flex-col overflow-hidden rounded-3xl border-2 border-l-8 shadow-md"
        [ngClass]="highlightedGuaranteeId() === guarantee.id ? 'border-warning-500' : 'border-primary-500'"
      >
        <div class="grid grid-cols-6 gap-16 px-4 py-1">
          <div
            class="col-span-2 flex cursor-pointer items-start gap-4"
            (click)="toggleExpansion(guarantee.id)"
          >
            <div class="flex flex-col gap-2">
              <span class="flex flex-col gap-1 text-neutral-300">
                <span class="text-xs text-neutral-300">
                  @switch (guarantee.creatorType) {
                    @case (creatorType.HealthManager) {
                      {{ "Створено НМом" }}
                    }
                    @case (creatorType.Doctor) {
                      @if (guarantee.isLiloStaff) {
                        {{ "Первинна консультація ПЛ" }}
                      }
                    }
                    @default {
                      {{ guarantee.description }}
                    }
                  }
                </span>
                <span class="flex items-center gap-4 text-lg font-semibold text-neutral-500">
                  {{ guarantee.description }}
                  @if (hasExpandableContent(guarantee)) {
                    <button class="h-6 w-6 rounded-full text-xs hover:bg-neutral-100">
                      <mat-icon class="text-neutral-500">{{ isExpanded(guarantee.id) ? "expand_more" : "chevron_right" }}</mat-icon>
                    </button>
                  }
                </span>
              </span>
              <span class="flex flex-col gap-1 text-neutral-500">
                <span class="text-sm text-neutral-300">ПІБ {{ guarantee.creatorType === creatorType.Doctor ? "лікаря:" : "менеджера:" }}</span>
                <span class="flex items-center gap-1">
                  {{ guarantee.creatorName }}
                  @if (guarantee.isLiloStaff) {
                    <shared-info-badge
                      [text]="'lilo'"
                      [color]="badgeColors.Blue"
                    ></shared-info-badge>
                  }
                </span>

                @if (withPatientName()) {
                  <span class="flex flex-col gap-1 text-neutral-500">
                    <span class="text-sm text-neutral-300">{{ "ПІБ клієнта: " }}</span>
                    <span
                      class="cursor-pointer font-semibold hover:underline"
                      (click)="navigateToMemberProfile(guarantee.userId)"
                    >
                      {{ guarantee.patientName }}
                    </span>
                  </span>
                }
              </span>
            </div>
          </div>
          <div class="col-span-3 flex place-content-between">
            <div class="flex flex-col gap-1">
              <span class="flex text-xs text-neutral-300">Діагнози</span>
              <prescriptions-diagnosis [guarantee]="guarantee"></prescriptions-diagnosis>
            </div>
            <div class="flex w-[125px] flex-col gap-1 text-start">
              <span class="text-xs text-neutral-300">Дата останньої зміни</span>
              <span class="text-sm">{{ formatDate(guarantee.lastUpdateDate, true) }}</span>
              @if (!guarantee.isLiloStaff) {
                <span class="text-xs text-neutral-300">Дата і час візиту</span>
                <span class="text-sm">{{ formatDate(guarantee.creationDate, true) }}</span>
              }
            </div>
          </div>
          <div class="col-span-1 flex place-content-between">
            <div class="flex flex-col gap-1">
              <div class="flex text-xs text-neutral-300">Статус гарантації</div>
              @if (guarantee.status) {
                <shared-status
                  [statusValue]="guarantee.status"
                  [statusMessage]="'statuses.guarantationStatuses.' + guarantee.status | translate"
                ></shared-status>
              }
              @if (guarantee.status === guaranteeStatuses.WaitProcessing) {
                <button
                  class="btn btn-primary py-2 text-sm font-thin"
                  [disabled]="findUnprocessedPrescriptions(guarantee)"
                  (click)="processGuarantee(guarantee)"
                >
                  {{ "Опрацювати" }}
                </button>
                @if (findUnprocessedPrescriptions(guarantee)) {
                  <p class="text-xs text-error-500">{{ "Опрацюйте всі призначення" }}</p>
                }
              }
            </div>
          </div>
        </div>
        <div class="flex items-center justify-between bg-primary-100">
          <div
            class="flex items-center gap-2"
            (click)="toggleExpansion(guarantee.id)"
          >
            @for (diagnosis of guarantee.diagnoses; track diagnosis) {
              <span class="ml-2 flex items-center text-neutral-300">
                @if (hasExpandableContent(guarantee) && $first) {
                  <button class="h-6 w-6 rounded-full text-xs hover:bg-neutral-100">
                    <mat-icon class="text-neutral-500">{{ isExpanded(guarantee.id) ? "expand_more" : "chevron_right" }}</mat-icon>
                  </button>
                }
                <span class="flex items-center gap-2 px-2 py-1 font-semibold text-neutral-500">
                  @if (diagnosis.icd10?.code) {
                    {{ diagnosis.icd10.code + " " + diagnosis.icd10.name }}
                  } @else if (diagnosis.icpc2?.code) {
                    {{ diagnosis.icpc2.code + " " + diagnosis.icpc2.name }}
                  } @else {
                    {{ "diagnoses.descriptions.unknown" | translate }}
                  }
                  <mat-icon [ngClass]="checkDiagnosisCoverage(guarantee, diagnosis) ? 'text-info-600' : 'text-error-600'">{{
                    checkDiagnosisCoverage(guarantee, diagnosis) ? "check_circle_outline" : "error_outline"
                  }}</mat-icon>
                </span>
              </span>
            }
          </div>
          @if (isExpanded(guarantee.id)) {
            <div class="flex items-center gap-2">
              <button
                class="text-md z-100 m-1 flex items-center gap-1 rounded-full px-4 py-1 font-thin text-neutral-300 underline hover:bg-neutral-50"
                type="button"
                (click)="checkGuaranteeSimilar(guarantee.id)"
              >
                <mat-icon>chronic</mat-icon>
                {{ "prescription.action.checkSimilarPrescriptions" | translate }}
              </button>
              @if (hasSelectedPrescriptions(guarantee.id)) {
                <div class="flex items-center gap-2 text-neutral-600">
                  <span>{{ getSelectedPrescriptionsForGuarantee(guarantee.id).length }} вибрано</span>
                  <button
                    type="button"
                    class="flex items-center gap-1 text-primary-600 hover:text-primary-800"
                    (click)="clearSelection(guarantee.id)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <button
                  class="text-md z-100 m-1 flex items-center gap-1 rounded-full bg-primary-500 px-4 py-1 font-thin text-neutral-0 hover:bg-primary-700"
                  type="button"
                  (click)="createAppointmentForSelection(guarantee.id)"
                >
                  @switch (selectedPrescriptionType()) {
                    @case (prescriptionTypes.LaboratoryService) {
                      <mat-icon>science</mat-icon>
                      {{ "Створити замовлення" }}
                    }
                    @default {
                      <mat-icon>medical_services</mat-icon>
                      {{ "Створити візит" }}
                    }
                  }
                </button>
              }
              @if (allowAddPrescription()) {
                <button
                  class="text-md z-100 m-1 flex items-center gap-1 rounded-full px-4 py-1 font-thin text-neutral-300 underline hover:bg-neutral-50"
                  type="button"
                  [matMenuTriggerFor]="addPrescriptionMenu"
                >
                  <mat-icon>add_circle_outline</mat-icon>
                  {{ "Додати призначення" }}
                </button>
              }
            </div>
            <mat-menu #addPrescriptionMenu="matMenu">
              <button
                mat-menu-item
                [type]="'button'"
                (click)="addPrescription(guarantee, prescriptionTypes.Drugs)"
              >
                <span class="flex items-center gap-1">
                  <img
                    alt="Medicines icon"
                    width="20"
                    height="20"
                    [ngSrc]="'assets/icons/ic_pill.svg'"
                  />
                  {{ "medicalServices.prescriptionTypes." + prescriptionTypes.Drugs | translate }}
                </span>
              </button>
              <button
                mat-menu-item
                [type]="'button'"
                (click)="addPrescription(guarantee, prescriptionTypes.PersonalDoctorAppointment)"
              >
                <span class="flex flex-nowrap items-center gap-1">
                  <img
                    alt="Doctor Appointment icon"
                    width="20"
                    height="20"
                    [ngSrc]="'assets/icons/ic_doctor.svg'"
                  />
                  {{ "medicalServices.prescriptionTypes." + prescriptionTypes.PersonalDoctorAppointment | translate }}</span
                >
              </button>
              <button
                mat-menu-item
                [type]="'button'"
                (click)="addPrescription(guarantee, prescriptionTypes.RelatedSpecialists)"
              >
                <span class="flex flex-nowrap items-center gap-1">
                  <img
                    alt="Doctor Appointment icon"
                    width="20"
                    height="20"
                    [ngSrc]="'assets/icons/ic_doctor.svg'"
                  />
                  {{ "medicalServices.prescriptionTypes." + prescriptionTypes.RelatedSpecialists | translate }}</span
                >
              </button>
              <button
                mat-menu-item
                [type]="'button'"
                (click)="addPrescription(guarantee, prescriptionTypes.LaboratoryService)"
              >
                <span class="flex items-center gap-1">
                  <img
                    alt="Laboratory Service icon"
                    width="20"
                    height="20"
                    [ngSrc]="'assets/icons/ic_laboratory.svg'"
                  />
                  {{ "medicalServices.prescriptionTypes." + prescriptionTypes.LaboratoryService | translate }}</span
                >
              </button>
              <button
                mat-menu-item
                [type]="'button'"
                (click)="addPrescription(guarantee, prescriptionTypes.InstrumentalDiagnostic)"
              >
                <span class="flex flex-nowrap items-center gap-1">
                  <img
                    alt="Instrumental Diagnostics icon"
                    width="20"
                    height="20"
                    [ngSrc]="'assets/icons/ic_diagnostics.svg'"
                  />
                  {{ "medicalServices.prescriptionTypes." + prescriptionTypes.InstrumentalDiagnostic | translate }}
                </span>
              </button>
              <button
                mat-menu-item
                [type]="'button'"
                (click)="addFreeFormPrescription(guarantee)"
              >
                <span class="flex flex-nowrap items-center gap-1">
                  <mat-icon class="mr-0 h-5 w-5 text-xl text-neutral-500">edit_note</mat-icon>
                  {{ "prescription.label.freeForm" | translate }}
                </span>
              </button>
            </mat-menu>
          }
        </div>
        @if (isExpanded(guarantee.id)) {
          <div
            class="bg-primary-100"
            role="group"
          >
            <!-- Drafts Section -->
            @if (getDraftsForGuarantee(guarantee.id).length > 0) {
              <div class="mb-2 px-2 text-sm font-semibold text-primary-600">{{ "prescription.label.drafts" | translate }}</div>
              @for (draft of convertDraftsToItems(getDraftsForGuarantee(guarantee.id)); track draft.id) {
                <div class="mx-2 mb-2">
                  <prescriptions-item
                    [memberId]="getMemberIdFromRoute()"
                    [prescription]="draft"
                    [allPrescriptions]="getAllPrescriptions()"
                    [showPrescriptionActions]="showPrescriptionActions()"
                    [checkSimilarSignal]="similarCheckTriggers()[guarantee.id] ?? 0"
                    (prescriptionUpdated)="updateGuarantee($event)"
                  ></prescriptions-item>
                </div>
              }
            }

            <!-- Regular Prescriptions Section -->
            @if (getFilteredPrescriptions(guarantee).length > 0) {
              <div class="mb-2 px-2 text-sm font-semibold text-primary-600">{{ "prescription.label.activePrescriptions" | translate }}</div>
              @for (prescription of getFilteredPrescriptions(guarantee); track prescription.id) {
                <div class="mx-2 mb-2">
                  <prescriptions-item
                    [memberId]="getMemberIdFromRoute()"
                    [prescription]="prescription"
                    [allPrescriptions]="getAllPrescriptions()"
                    [selectable]="true"
                    [selected]="selectedPrescriptions().includes(prescription)"
                    [selectionEnabled]="isPrescriptionSelectionEnabled(guarantee.id, prescription)"
                    [showPrescriptionActions]="showPrescriptionActions()"
                    [checkSimilarSignal]="similarCheckTriggers()[guarantee.id] ?? 0"
                    [guaranteeAwaitingProcessing]="guarantee.status === guaranteeStatuses.WaitProcessing"
                    (prescriptionUpdated)="updateGuarantee($event)"
                    (selectionToggled)="onPrescriptionSelectionToggled(guarantee.id, $event)"
                  ></prescriptions-item>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  } @else {
    <div class="flex items-center justify-center rounded-2xl border-2 border-dashed border-neutral-200 py-14 pr-3 text-neutral-300">
      <h4>За цим запитом нічого не знайдено</h4>
    </div>
  }
</div>
@if (loading()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-neutral-0/80">
    <shared-loader></shared-loader>
  </div>
}
